import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", { href: "https://crowdin.com/project/randomly-adding-anything" }, "Randomly Adding Anything Core", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { href: "https://crowdin.com/project/randomly-adding-anything-mater" }, "Randomly Adding Anything Materials", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('translate-crowdin')), 1),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3
  ]))
}